import axios from 'axios';
import {
  GET_VAIX_SEARCH_PRE_SEARCH_REQUEST,
  GET_VAIX_SEARCH_PRE_SEARCH_SUCCESS,
  GET_VAIX_SEARCH_PRE_SEARCH_FAILURE,
  GET_VAIX_SEARCH_AFTER_SEARCH_REQUEST,
  GET_VAIX_SEARCH_AFTER_SEARCH_SUCCESS,
  GET_VAIX_SEARCH_AFTER_SEARCH_FAILURE,
  GET_VAIX_SEARCH_AFTER_SEARCH_GAMELIST_EVENT_REQUEST,
  GET_VAIX_SEARCH_AFTER_SEARCH_GAMELIST_EVENT_SUCCESS,
  GET_VAIX_SEARCH_AFTER_SEARCH_GAMELIST_EVENT_FAILURE
} from 'Store/constants';
import errorMessage from './errorMessage';
import ProjectConfig from 'ProjectConfig';

const API_GATEWAY = ProjectConfig.API_GATEWAY;

export const getVSAuthPreSearch = (count = 10, recentSearchCount = 5) => async (dispatch, getState) => {
  try {
    dispatch({
      type: GET_VAIX_SEARCH_PRE_SEARCH_REQUEST
    });

    if (getState().auth.isAuthenticated) {
      const res = await axios.get(`${API_GATEWAY}/v3/mobile/aggregator/main-page/auth/pre-search?count=${count}&recentSearchCount=${recentSearchCount}`);
      dispatch({
        type: GET_VAIX_SEARCH_PRE_SEARCH_SUCCESS,
        payload: res.data
      });
      return res.data;
    }
  } catch (e) {
    dispatch({
      type: GET_VAIX_SEARCH_PRE_SEARCH_FAILURE,
      payload: errorMessage
    });
  }
};

export const resetVaixPreSearch = () => dispatch => {
  dispatch({
    type: GET_VAIX_SEARCH_PRE_SEARCH_SUCCESS,
    payload: null
  });
};

export const getVSAfterSearchResults = (token, filters) => async (dispatch, getState) => {
  try {
    dispatch({
      type: GET_VAIX_SEARCH_AFTER_SEARCH_REQUEST
    });

    if (getState().auth.isAuthenticated) {
      let url = `${API_GATEWAY}/v3/mobile/aggregator/main-page/auth/search/v2?token=${token}`;

      if (filters) {
        url += `&mode=RECOMMENDED&filters=sport_id:eq:${filters}`;
      }

      const res = await axios.get(url);
      dispatch({
        type: GET_VAIX_SEARCH_AFTER_SEARCH_SUCCESS,
        payload: res.data
      });
      return res.data;
    }
  } catch (e) {
    dispatch({
      type: GET_VAIX_SEARCH_AFTER_SEARCH_FAILURE,
      payload: errorMessage
    });
  }
};

export const getVSGameListEventsCached = eventIds => async (dispatch, getState) => {
  try {
    dispatch({
      type: GET_VAIX_SEARCH_AFTER_SEARCH_GAMELIST_EVENT_REQUEST
    });

    if (getState().auth.isAuthenticated) {
      const res = await axios.get(`${API_GATEWAY}/v3/mobile/aggregator/gamelist/events/cached/v2`, {
        params: {
          eventIds: eventIds.join(',')
        }
      });
      dispatch({
        type: GET_VAIX_SEARCH_AFTER_SEARCH_GAMELIST_EVENT_SUCCESS,
        payload: res.data
      });
      return res.data;
    }
  } catch (e) {
    dispatch({
      type: GET_VAIX_SEARCH_AFTER_SEARCH_GAMELIST_EVENT_FAILURE,
      payload: errorMessage
    });
  }
};
